import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const CheckIconGreen: FC<IconV2Props> = ({ icon, className }) => (
  <svg
    className={cn(s.svg24, `svg-icon--${icon}`, className)}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 0C3.81 0 0 3.81 0 8.5 0 13.19 3.81 17 8.5 17S17 13.19 17 8.5C17 3.81 13.19 0 8.5 0zM7.19 12.46 3.72 8.99l1.14-1.18 2.18 2.26 5.53-5.53 1.27 1.27-6.65 6.65z"
      style={{ fill: '#00884f' }}
    />
  </svg>
);

export default CheckIconGreen;
